{
	"$schema": "./schema.json",
	"name": "Default",
	"colorSchemes": {
		"dark": {
			"pcbLayers": {
				"colorsByType": [
					{
						"layerType": "F",
						"colors": ["rgba(205,67,65,0.8)"]
					},
					{
						"layerType": "B",
						"colors": ["rgba(95,169,230,0.8)"]
					},
					{
						"layerType": "Inner",
						"colors": [
							"rgba(255,231,76,0.8)",
							"rgba(145,209,120,0.8)",
							"rgba(255,221,161,0.8)",
							"rgba(95,173,86,0.8)",
							"rgba(0,191,178,0.8)",
							"rgba(101,222,241,0.8)",
							"rgba(197,94,163,0.8)",
							"rgba(245,100,22,0.8)",
							"rgba(200,52,52,0.8)"
						]
					},
					{
						"layerType": "Edge",
						"colors": ["rgba(199,199,199,1.0)"]
					},
					{
						"layerType": "Other",
						"colors": ["#52D1DC", "#006992", "rgb(12,149,144)", "#AFD2E9", "#73007D", "#00538A", "#A09BE7"]
					},
					{
						"layerType": "SilkS",
						"front": ["#BA9797"],
						"back": ["#9EB1C0"],
						"colors": ["#B3B3B3"]
					},
					{
						"layerType": "Mask",
						"front": ["#E9A15D"],
						"back": ["#C56D1B"],
						"colors": ["#E48C3A"]
					},
					{
						"layerType": "Paste",
						"back": ["#9FD0C6"],
						"front": ["#5BAE9E"],
						"colors": ["#4A9687", "#76BCAE"]
					}
				]
			},
			"schLayers": {
				"colorsByType": [
					{
						"layerType": "Background",
						"colors": ["#5F5F3C"]
					},
					{
						"layerType": "Bus",
						"colors": ["rgba(0,0,132,0.9)"]
					},
					{
						"layerType": "BusJunction",
						"colors": ["rgba(0,0,132,0.9)"]
					},
					{
						"layerType": "Label",
						"colors": ["#0FC8DB"]
					},
					{
						"layerType": "Wire",
						"colors": ["#0FC8DB"]
					},
					{
						"layerType": "Junction",
						"colors": ["#0FC8DB"]
					},
					{
						"layerType": "Pin",
						"colors": ["#FFFFFF"]
					},
					{
						"layerType": "PinNumber",
						"colors": ["#FFFFFF"]
					},
					{
						"layerType": "Symbol",
						"colors": ["#4975FF"]
					},
					{
						"layerType": "PinName",
						"colors": ["#FFFFFF"]
					},
					{
						"layerType": "NameLabel",
						"colors": ["#0FC8DB"]
					},
					{
						"layerType": "ValueLabel",
						"colors": ["#0FC8DB"]
					},
					{
						"layerType": "Image",
						"colors": ["rgba(255,255,255,0.6)"]
					}
				]
			},
			"tools": {
				"default": {
					"default": "#C43E49",
					"overlay": "#7a7a7a",
					"selectedElements": "#f2c64b",
					"userSelection": "#a86932",
					"background": "#252525"
				},
				"iruler": {
					"default": "#FFFFFF",
					"textShadow": "#000000"
				},
				"grid": {
					"default": "#848484",
					"major": "#848484"
				},
				"probe": {
					"neg": "#FFFFFF",
					"pos": "#FF0000"
				}
			}
		},
		"light": {
			"pcbLayers": {
				"colorsByType": [
					{
						"layerType": "F",
						"colors": ["rgba(205,67,65,0.8)"]
					},
					{
						"layerType": "B",
						"colors": ["rgba(95,169,230,0.8)"]
					},
					{
						"layerType": "Inner",
						"colors": [
							"rgba(255,231,76,0.8)",
							"rgba(145,209,120,0.8)",
							"rgba(255,221,161,0.8)",
							"rgba(95,173,86,0.8)",
							"rgba(0,191,178,0.8)",
							"rgba(101,222,241,0.8)",
							"rgba(197,94,163,0.8)",
							"rgba(245,100,22,0.8)",
							"rgba(200,52,52,0.8)"
						]
					},
					{
						"layerType": "Edge",
						"colors": ["#4F4F4F"]
					},
					{
						"layerType": "Other",
						"colors": ["#52D1DC", "#006992", "rgb(12,149,144)", "#AFD2E9", "#73007D", "#00538A", "#A09BE7"]
					},
					{
						"layerType": "SilkS",
						"front": ["#BA9797"],
						"back": ["#9EB1C0"],
						"colors": ["#B3B3B3"]
					},
					{
						"layerType": "Mask",
						"front": ["#E9A15D"],
						"back": ["#C56D1B"],
						"colors": ["#E48C3A"]
					},
					{
						"layerType": "Paste",
						"back": ["#9FD0C6"],
						"front": ["#5BAE9E"],
						"colors": ["#4A9687", "#76BCAE"]
					}
				]
			},
			"schLayers": {
				"colorsByType": [
					{
						"layerType": "Background",
						"colors": ["rgba(255,255,194,0.8)"]
					},
					{
						"layerType": "Bus",
						"colors": ["rgba(0,0,132,0.9)"]
					},
					{
						"layerType": "BusJunction",
						"colors": ["rgba(0,0,132,0.9)"]
					},
					{
						"layerType": "Label",
						"colors": ["#042F49"]
					},
					{
						"layerType": "Wire",
						"colors": ["#042F49"]
					},
					{
						"layerType": "Junction",
						"colors": ["#042F49"]
					},
					{
						"layerType": "Pin",
						"colors": ["#000000"]
					},
					{
						"layerType": "PinNumber",
						"colors": ["#000000"]
					},
					{
						"layerType": "Symbol",
						"colors": ["#2746E2"]
					},
					{
						"layerType": "PinName",
						"colors": ["#000000"]
					},
					{
						"layerType": "NameLabel",
						"colors": ["#042F49"]
					},
					{
						"layerType": "ValueLabel",
						"colors": ["#042F49"]
					},
					{
						"layerType": "Image",
						"colors": ["#FFFFFF"]
					}
				]
			},
			"tools": {
				"default": {
					"default": "#52D1DC",
					"overlay": "#7a7a7a",
					"selectedElements": "#a86932",
					"userSelection": "#a86932",
					"background": "#252525"
				},
				"iruler": {
					"default": "#000000",
					"textShadow": "#FFFFFF"
				},
				"grid": {
					"default": "#B5B5B5",
					"major": "#B5B5B5"
				},
				"probe": {
					"neg": "#000000",
					"pos": "#FF0000"
				}
			}
		}
	}
}
